<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">Change Password</h3>
        <p class="card-subtitle">Set up a New password.</p>
        <vs-row>
          <vs-col>
            <vs-input label="Current Password" type="password" v-model="password.oldPassword" />
          </vs-col>
          <vs-col>
            <vs-input label="New Password" type="password" v-model="password.newPassword" />
          </vs-col>
          <vs-col>
            <vs-input label="Confirm Password" type="password" v-model="confirmPassword" @keyup.enter="save"/>
          </vs-col>
          <vs-col>
            <vs-button @click="save">Change Password</vs-button>
          </vs-col>
        </vs-row>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "../../../../src/common/constants";
export default {
  name: "change-password",
  data: () => ({
    password: {
      newPassword: "",
      oldPassword: ""
    },
    confirmPassword: ""
  }),
  computed: {},
  methods: {
    save() {
      if(this.password.newPassword !== this.confirmPassword){
        this.$vs.notify({
          title: "Password Mismatch",
          text: "Passwords do not match!",
          color: "danger",
          position: "top-right"
        });
        return;
      }
      this.$vs.loading();
      api
        .post(API.CHANGE, this.$data.password)
        .then(r => {
          this.$vs.loading.close();
          if (r.data.status) {
            this.password = {
              newPassword: "",
              oldPassword: "",
            };
            this.confirmPassword = "";
            this.$emit("passwordUpdated")
            this.$vs.notify({
              text: "Password Changed Successfully!",
              color: "success",
              position: "right"
            });
          } else {
            this.$vs.notify({
              title: "Password Error",
              text: r.data.error,
              color: "danger",
              position: "right"
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
            this.$vs.notify({
            title: "Error",
            text: err.response.data.message,
            color: "danger",
            position: "top-right",
            });
        });
    }
  },
  created() {}
};
</script>
<style scoped>
</style>
